export const BASE_URL = process.env.NODE_ENV !== "production" ? "https://sys.smeg.com.au" : "";
export const VVCALL_URL = `${BASE_URL}/valence/vvcall.pgm`;
export const VVUPLOAD_URL = `${BASE_URL}/valence/vvupload.pgm`;
export const VVLOGIN_URL = `${BASE_URL}/valence/vvlogin.pgm`;
